export default __webpack_public_path__ + "static/brojkeBg2025-35cb35c0fffa610a49240e430b48792a.jpg";